"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _RatingItem = require("./RatingItem.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Rating Item component
 */

/* eslint-disable no-console */
var RatingItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RatingItem, _React$PureComponent);

  var _super = _createSuper(RatingItem);

  function RatingItem() {
    var _this;

    _classCallCheck(this, RatingItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "ratingClickHandler", function () {
      return _this.props.ratingClickHandler(_this.props.value);
    });

    _defineProperty(_assertThisInitialized(_this), "mouseEnter", function () {
      return _this.props.hoverHandler(_this.props.value);
    });

    _defineProperty(_assertThisInitialized(_this), "mouseLeave", function () {
      return _this.props.hoverHandler(0);
    });

    return _this;
  }

  _createClass(RatingItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          isFeedbackSubmitted = _this$props.isFeedbackSubmitted,
          ratingClickHandler = _this$props.ratingClickHandler,
          ratingType = _this$props.ratingType,
          value = _this$props.value,
          props = _objectWithoutProperties(_this$props, ["active", "className", "dataTestId", "isFeedbackSubmitted", "ratingClickHandler", "ratingType", "value"]);

      return /*#__PURE__*/_react.default.createElement(_RatingItem.StyledRatingItem, _extends({
        className: className,
        "data-test-id": dataTestId
      }, props), isFeedbackSubmitted ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: "rating-item-icon",
        colorTheme: active ? 'primary' : 'disabled',
        dataTestId: "rating-item-icon",
        iconName: ratingType,
        size: "large"
      }) : /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        className: isFeedbackSubmitted ? '' : 'c-rating-item-accepts-hover',
        colorTheme: active ? 'primary' : 'disabled',
        dataTestId: "rating-item-icon-button",
        iconName: ratingType,
        onClick: this.ratingClickHandler,
        onMouseEnter: this.mouseEnter,
        onMouseLeave: this.mouseLeave,
        size: "large"
      }));
    }
  }]);

  return RatingItem;
}(_react.default.PureComponent);

_defineProperty(RatingItem, "propTypes", {
  /** If the start should be active(green) or inactive(light-grey) */
  active: _propTypes.PropTypes.bool,

  /** Styling hook */
  className: _propTypes.PropTypes.string,

  /** Test ID hook */
  dataTestId: _propTypes.PropTypes.string.isRequired,

  /** function to handle hover state */
  hoverHandler: _propTypes.PropTypes.func.isRequired,

  /** Rating and Feedback has been submitted */
  isFeedbackSubmitted: _propTypes.PropTypes.bool,

  /** onClick function for the rating */
  ratingClickHandler: _propTypes.PropTypes.func.isRequired,

  /** Specifies icon to display for the scale */
  ratingType: _propTypes.PropTypes.oneOf([undefined, 'star']),

  /** The value of the rating (depends on ratingScale) */
  value: _propTypes.PropTypes.number.isRequired
});

_defineProperty(RatingItem, "defaultProps", {
  active: false,
  className: '',
  isFeedbackSubmitted: false,
  ratingType: 'star'
});

var _default = RatingItem;
exports.default = _default;